// extracted by mini-css-extract-plugin
module.exports = {"wrap":"sd","heading":"td"};